import React from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@material-ui/core'
import { useTranslation } from '../../contexts/i18n/use'
import useTheme from '@material-ui/core/styles/useTheme'
import makeStyles from '@material-ui/core/styles/makeStyles'

export const CheckinErrorDialog = ({text, cancelcallback}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const { actions: {t}} = useTranslation();

  return (
    <Dialog 
      open={true} 
      classes={{paper: classes.modal}}
      className="checkinpage-error-root"
      >
      <DialogTitle className={classes.title}>
          <Typography 
            className={classes.header}
            id="checkinpage-error-header"
          >
            { text }
          </Typography>
        </DialogTitle>
      <DialogActions className={classes.buttonwrapper}>
        <Button className={[classes.cancelbutton, "dialogbutton"].join(' ')} id="checkinpage-error-decline-button" onClick={x => cancelcallback()}>
          <Typography id="checkinpage-error-decline-button-text">
            { t('checkinpage.error.cancel')}
          </Typography>
        </Button>
      </DialogActions>
    </Dialog>
  )
}

const useStyles = makeStyles({
    wrapper: {
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column'
    },
    modal: theme => ({
        border: '1px solid '+ theme.palette.primary.main,
        alignItems: 'center',
        justifyContent: 'center',
        width: "80%",
        height: '50%',
        maxHeight: '300px',
        maxWidth: '300px',
        display: 'flex',
        flexDirection: 'column'
    }),
    title: {
        height: '80%',
        width: '80%',
        padding: 0,
        textAlign: 'center'
    },
    header: {
        fontSize: "1rem"
    },
    buttonwrapper: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '80%',
        padding: 0
    },
  cancelbutton: theme => ({
    backgroundColor: theme.palette.info.main,
    color: theme.palette.button_text.main,
    [theme.breakpoints.up('lg')]: {
      '&:hover': {
        backgroundColor: 'black',
        color: 'white'
      }
    },
    [theme.breakpoints.down('lg')]: {
      '&:hover': {
        backgroundColor: theme.palette.info.main,
        color: theme.palette.button_text.main
      }
    }
  })
})